import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-vidicon-2-line text-xl" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">金桔影院</span>
            <span className="text-[10px] tracking-[0.3em] text-primary-700">JINJU CINEMA</span>
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#address"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            查看最新地址
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开导航菜单"
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300/70 text-foreground-800 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 lg:hidden">
          <nav className="mx-auto flex max-w-7xl flex-col gap-1 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#address"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-center text-sm font-medium text-background-50"
            >
              查看最新地址
            </a>
          </nav>
        </div>
      ) : null}
    </header>
  );
}